import { ReactNode } from "react";
import { Footer, Nav } from "features/Nav";
import GlobalLayout from "./GlobalLayout";

export default function DefaultLayout({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <GlobalLayout>
      <Nav />
      {children}
      <Footer />
    </GlobalLayout>
  );
}

export const DefaultLayoutWrapper = (page) => DefaultLayout({children: page});